import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { Item } from '../utils/sharedTypes';
import {
  convertItemToPlural,
  prettyPrintItem,
} from '../utils/stringManipulation';
import useStyles from './itemDialogStyles';

const DeleteItemDialog = ({
  deleteModalOpen,
  setDeleteModalOpen,
  itemDeleter,
  itemsToDelete,
  setSelectedItems,
  itemName,
  deleteNotes,
}: {
  deleteModalOpen: boolean;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  itemDeleter: Function;
  itemsToDelete: Array<Item>;
  setSelectedItems: Function;
  // Optional item name that replaces "Item" in dialog headers
  itemName?: string;
  // Optional notes displayed in the dialog
  deleteNotes?: string;
}) => {
  const classes = useStyles();
  const [submitted, setSubmitted] = useState(false);
  const [deleteResults, setDeleteResults] = useState([
    'Click Delete to delete items',
  ]);
  const handleClose = () => {
    setDeleteModalOpen(false);
    setDeleteResults(['Click Delete to delete items']);
    setSubmitted(false);
    setSelectedItems([]);
  };
  const handleCancel = () => {
    setDeleteModalOpen(false);
    setDeleteResults(['Click Delete to delete items']);
    setSubmitted(false);
  };
  const handleSubmit = async () => {
    setDeleteResults([]);
    for (const item of itemsToDelete) {
      const result = await itemDeleter({ id: item.id });
      if ('error' in result) {
        setDeleteResults((results) => [
          ...results,
          `Failed to delete item. ${result.error.data.message}`,
        ]);
      } else {
        setDeleteResults((results) => [
          ...results,
          'Item successfully deleted',
        ]);
      }
    }
    setSubmitted(true);
  };
  return (
    <Dialog
      fullWidth
      open={deleteModalOpen}
      aria-labelledby='form-dialog-title'
    >
      <DialogTitle id='form-dialog-title'>
        Delete {itemName ? convertItemToPlural(itemName) : 'Items'}
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.indentedHeader}>
          Items To Delete
        </Typography>
        <Divider />
        <List>
          {itemsToDelete.map((item, index) => (
            <ListItem key={index}>
              <Typography>{prettyPrintItem(item)}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography className={classes.indentedHeader} variant='subtitle1'>
          Results
        </Typography>
        <Divider />
        <List>
          {deleteResults.map((result, index) => (
            <ListItem key={index}>
              <Typography>{result}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography color='error'>{deleteNotes}</Typography>
      </DialogContent>
      {submitted ? (
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Close
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button onClick={handleCancel} color='primary'>
            Cancel
          </Button>
          <Button onClick={handleSubmit} color='error'>
            Delete
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DeleteItemDialog;
